var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('profile.loggedinas', {name: _vm.user.name})))]),(_vm.$te('profile.intro'))?_c('vue-markdown',{attrs:{"source":_vm.$t('profile.intro', {
    brand: _vm.brand,
    name: _vm.user.name,
    username: _vm.user.username,
    email: _vm.user.email
  })}}):_vm._e(),(_vm.devmode)?_c('pre',[_vm._v(_vm._s(_vm.user))]):_vm._e(),_c('b-table',{attrs:{"stacked":"","items":[this.user],"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }